/* Product-page conversion blocks — behaviour. Every function does nothing if
   its block is not on the page, and each element is bound once, so the theme
   editor can re-render sections freely. */
(function () {
  'use strict';

  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Copy the discount code ─────────────────────────────────────────── */
  function bindCopy(root) {
    $$('[data-copy]', root).forEach(function (btn) {
      if (btn.__bound) { return; }
      btn.__bound = true;
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-copy') || '';
        var done = btn.querySelector('.pdpb-code__done');
        var show = function () {
          btn.classList.add('is-done');
          if (done) { done.hidden = false; }
          setTimeout(function () {
            btn.classList.remove('is-done');
            if (done) { done.hidden = true; }
          }, 1800);
        };
        var fallback = function () {
          try {
            var ta = document.createElement('textarea');
            ta.value = code;
            ta.setAttribute('readonly', '');
            ta.style.cssText = 'position:absolute;left:-9999px';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            ta.remove();
            show();
          } catch (e) { /* nothing sensible left to try */ }
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(show, fallback);
        } else {
          fallback();
        }
      });
    });
  }

  /* ── Delivery timeline ──────────────────────────────────────────────────
     Worked out in the visitor's own clock, so a cached page never shows
     yesterday's dates. Before the cut-off the order is dispatched today;
     after it (or on a Sunday, when the courier does not collect) it goes the
     next working day. Delivery is counted in working days from the order. */
  function bindTimeline(root) {
    var boxes = $$('[data-timeline]', root).filter(function (b) { return !b.__bound; });
    if (!boxes.length) { return; }

    var fmt = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };

    function nextWorkingDay(d, skipSunday) {
      var x = new Date(d);
      do { x.setDate(x.getDate() + 1); } while (skipSunday && x.getDay() === 0);
      return x;
    }
    function addWorkingDays(d, n, skipSunday) {
      var x = new Date(d);
      for (var i = 0; i < n; i++) { x = nextWorkingDay(x, skipSunday); }
      return x;
    }

    boxes.forEach(function (box) {
      box.__bound = true;
      var hour = parseInt(box.getAttribute('data-cutoff-hour'), 10);
      if (isNaN(hour)) { hour = 15; }
      var dMin = parseInt(box.getAttribute('data-deliver-min'), 10) || 3;
      var dMax = parseInt(box.getAttribute('data-deliver-max'), 10) || 5;
      if (dMax < dMin) { dMax = dMin; }
      var skipSunday = box.getAttribute('data-skip-sunday') !== 'false';

      var clock = box.querySelector('[data-countdown]');
      var shipWord = box.querySelector('[data-ship-word]');
      var elOrdered = box.querySelector('[data-t-ordered]');
      var elShipped = box.querySelector('[data-t-shipped]');
      var elDelivered = box.querySelector('[data-t-delivered]');

      function tick() {
        var now = new Date();
        var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        var cutoffToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), hour, 0, 0, 0);
        var sendsToday = now < cutoffToday && !(skipSunday && now.getDay() === 0);

        var shipDay = sendsToday ? today : nextWorkingDay(today, skipSunday);
        var deadline = new Date(shipDay.getFullYear(), shipDay.getMonth(), shipDay.getDate(), hour, 0, 0, 0);
        var left = Math.max(0, deadline - now);
        var h = Math.floor(left / 3600000);
        var m = Math.floor((left % 3600000) / 60000);
        var s = Math.floor((left % 60000) / 1000);

        if (clock) { clock.textContent = h > 0 ? h + 'h ' + pad(m) + 'm' : pad(m) + 'm ' + pad(s) + 's'; }
        if (shipWord) {
          var tomorrow = nextWorkingDay(today, false);
          shipWord.textContent = sendsToday ? 'today'
            : (shipDay.getTime() === tomorrow.getTime() ? 'tomorrow' : 'on ' + shipDay.toLocaleDateString('en-US', { weekday: 'long' }));
        }
        if (elOrdered) { elOrdered.textContent = 'Today'; }
        if (elShipped) { elShipped.textContent = sendsToday ? 'Today' : fmt(shipDay); }
        if (elDelivered) {
          var a = addWorkingDays(today, dMin, skipSunday);
          var b = addWorkingDays(today, dMax, skipSunday);
          elDelivered.textContent = fmt(a) + (dMax > dMin ? ' – ' + fmt(b) : '');
        }
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ── Review rows: swipe on a phone, arrows and dots everywhere ──────── */
  function bindReviewRows(root) {
    $$('[data-jmr-row]', root).forEach(function (row) {
      if (row.__bound) { return; }
      row.__bound = true;
      var track = row.querySelector('[data-jmr-track]');
      var prev = row.querySelector('[data-jmr-prev]');
      var next = row.querySelector('[data-jmr-next]');
      var dotsWrap = row.querySelector('[data-jmr-dots]');
      if (!track) { return; }
      var cards = $$('.jmr', track);
      var foot = row.querySelector('.jmr-row__foot');
      if (cards.length < 2) { if (foot) { foot.hidden = true; } return; }

      var step = function () {
        var c = cards[0].getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 12;
        return c + gap;
      };
      var index = function () { return Math.round(track.scrollLeft / Math.max(1, step())); };
      var go = function (i) {
        track.scrollTo({ left: i * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
      };

      var dots = [];
      if (dotsWrap) {
        cards.forEach(function (c, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'jmr-row__dot' + (i === 0 ? ' is-active' : '');
          b.setAttribute('aria-label', 'Review ' + (i + 1));
          b.addEventListener('click', function () { go(i); });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }

      var sync = function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) { prev.disabled = track.scrollLeft <= 2; }
        if (next) { next.disabled = track.scrollLeft >= max; }
        var cur = track.scrollLeft >= max ? cards.length - 1 : index();
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === cur); });
      };
      if (prev) { prev.addEventListener('click', function () { go(Math.max(0, index() - 1)); }); }
      if (next) { next.addEventListener('click', function () { go(Math.min(cards.length - 1, index() + 1)); }); }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });

    $$('[data-jmr-more]', root).forEach(function (btn) {
      if (btn.__bound) { return; }
      btn.__bound = true;
      btn.addEventListener('click', function () {
        var body = btn.closest('[data-jmr-body]');
        if (!body) { return; }
        var open = !body.classList.contains('is-open');
        body.classList.toggle('is-open', open);
        btn.textContent = open ? 'Show less' : 'Read more';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ── "Read all reviews" lands on the Judge.me widget ─────────────────
     The widget is rendered by the Judge.me app block, so it may not exist
     yet when the page first paints; look for it at click time. */
  function findReviewsWidget() {
    return document.getElementById('judgeme_product_reviews') ||
      document.querySelector('.jdgm-review-widget:not(.jdgm-hidden)') ||
      document.querySelector('.jdgm-widget.jdgm-review-widget') ||
      document.getElementById('product-reviews');
  }
  function jumpToReviews(e) {
    var target = findReviewsWidget();
    if (!target) { return; }
    if (e) { e.preventDefault(); }
    var tabBtn = target.closest('[data-panel]') ? document.querySelector('[data-tab="' + target.closest('[data-panel]').getAttribute('data-panel') + '"]') : null;
    if (tabBtn) { tabBtn.click(); }
    var header = document.querySelector('.header, header, [data-header]');
    var offset = header ? Math.min(header.getBoundingClientRect().height, 120) + 12 : 80;
    var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: y, behavior: reduceMotion ? 'auto' : 'smooth' });
  }
  function bindJumps(root) {
    $$('a[href="#judgeme_product_reviews"], [data-jump-reviews]', root).forEach(function (a) {
      if (a.__bound) { return; }
      a.__bound = true;
      a.addEventListener('click', jumpToReviews);
    });
  }

  /* ── Keep the gallery in view on a desktop, if it fits the window ───── */
  function bindStickyMedia() {
    var media = document.querySelector('.product__media');
    if (!media || media.__bound) { return; }
    media.__bound = true;
    var check = function () {
      var fits = window.innerWidth >= 900 && media.offsetHeight + 40 < window.innerHeight;
      media.classList.toggle('is-sticky', fits);
    };
    check();
    window.addEventListener('resize', check);
    window.addEventListener('load', check);
  }

  function boot(root) {
    bindCopy(root);
    bindTimeline(root);
    bindReviewRows(root);
    bindJumps(root);
    bindStickyMedia();
  }

  if (document.readyState !== 'loading') { boot(document); }
  else { document.addEventListener('DOMContentLoaded', function () { boot(document); }); }
  if (location.hash === '#judgeme_product_reviews') {
    window.addEventListener('load', function () { setTimeout(function () { jumpToReviews(null); }, 400); });
  }

  // The theme editor re-renders a section in place; bind whatever is new.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  // The review wall on other pages shares the review rows.
  window.NYLA_bindReviewRows = bindReviewRows;
})();
